import comp from "./EvaluationCycles";
export default comp;
